const divConfirmTenant = {
  access: 'Acceso agregado con éxito',
  link: 'Enlace caducado'
};

export default divConfirmTenant;
